import {Component, inject} from '@angular/core';
import {CustomErrorComponent} from '../../shared/custom-error.component';
import {EnglishDigitsOnlyAndFullStopDirectiveDirective} from '../../shared/english-digits-onlyAndFullStop.directive';
import {ExistCodeDirective} from '../../shared/validate/exist-product-menu-code';
import {FileImageComponent} from '../../shared/components/file-image/file-image.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgIf} from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-anounce-page',
  standalone: true,
  imports: [
    CustomErrorComponent,
    EnglishDigitsOnlyAndFullStopDirectiveDirective,
    ExistCodeDirective,
    FileImageComponent,
    FormsModule,
    NgIf,
    ReactiveFormsModule
  ],
  templateUrl: './announce-page.component.html',
  styleUrl: './announce-page.component.scss'
})
export class AnnouncePageComponent {
  public activeModal =inject(NgbActiveModal)


}
